<template>
  <div>
    <v-checkbox v-for="option in selectedDisplayOptions" :key="option.value"
                :input-value="configSelectedDisplay[option.value]" :indeterminate="configSelectedDisplay[option.value] == null" class="my-0"
                @click.native="handleCheck(option.value)">
      <template #label>{{ option.text }}</template>
    </v-checkbox>
  </div>
</template>

<script>
  export default {
    props: {
      configSelectedDisplay: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        selectedDisplayOptions: [
          { value: 'description', text: this.$t('WORKING_VIEWS.DESCRIPTION') },
          { value: 'checklist', text: this.$t('WORKING_VIEWS.CHECKLIST') },
          { value: 'progress', text: this.$t('WORKING_VIEWS.PROGRESS') },
          { value: 'users', text: this.$t('WORKING_VIEWS.USERS') },
          { value: 'dates', text: this.$t('WORKING_VIEWS.DATES') },
          { value: 'links', text: this.$t('WORKING_VIEWS.LINKS') },
          { value: 'budgets', text: this.$t('WORKING_VIEWS.BUDGETS') },
        ],
      };
    },
    methods: {
      handleCheck(item) {
        const configSelectedDisplay = { ...this.configSelectedDisplay };
        if (this.configSelectedDisplay[item] == null) {
          configSelectedDisplay[item] = true;
        } else if (this.configSelectedDisplay[item] == true) {
          configSelectedDisplay[item] = false;
        } else {
          configSelectedDisplay[item] = null; // set default value
        }
        this.$emit('update:config-selected-display', configSelectedDisplay);
      },
    },
  };
</script>
